import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { LookupValuesService } from "../../../services/settings/lookupvalues.service";

@Component({
    standalone: false,
    selector: "lookupvalues-form",
    templateUrl: "./lookupvalues.form.component.html",
    providers: [LookupValuesService],
})
export class FormLookupValues {
    @Input() type: string = "";
    @Input() header: string = "";
    @Output("refreshTable")
    refreshTable: EventEmitter<void> = new EventEmitter<void>();
    form: FormGroup;
    model: any = {};
    showNote: boolean = false;
    fields: Array<FormlyFieldConfig> = [];
    isValidInput: boolean = false;

    constructor(private fb: FormBuilder, private service: LookupValuesService) {
        this.form = fb.group({});
    }

    ngOnInit() {
        if (this.type == "SubContractorPaymentTerms") {
            this.showNote = true;
        }

        if (this.type == "SubContractorPackage") {
            this.showNote = true;
        }

        this.fields = [
            {
                fieldGroup: [
                    {
                        className: "full-width",
                        key: "lookupValues",
                        type: "hz-textarea",
                        props: {
                            type: "text",
                            note:
                                this.showNote == true
                                    ? "Delete and Deactivate options are unavailable for items which have already been used in the Subcontractor Payment form"
                                    : "Please note the character limit for this field is 40 characters per row",
                            required: true,
                            keyup: ($event) => {
                                this.isValidInput = true;
                                const lookupValuesArr = (
                                    this.model.lookupValues || ""
                                ).split("\n");
                                for (
                                    let i = 0;
                                    i < lookupValuesArr.length;
                                    i++
                                ) {
                                    var stringToCheck = lookupValuesArr[i];

                                    if (stringToCheck.length > 40) {
                                        this.isValidInput = false;
                                    }

                                    if (this.isEmptyOrSpaces(stringToCheck)) {
                                        this.isValidInput = false;
                                    }
                                }

                                return this.isValidInput;
                            },
                        },
                    },
                ],
            },
        ];
    }

    private isEmptyOrSpaces(str: string) {
        return str === null || str.match(/^ *$/) !== null;
    }

    process() {
        if (this.form.valid) {
            const lookupValues: any[] = [];
            const lookupValuesArr = (this.model.lookupValues || "").split("\n");

            for (let i = 0; i < lookupValuesArr.length; i++) {
                lookupValues.push({
                    Name: lookupValuesArr[i],
                    Status: "Active",
                    Type: this.type,
                });
            }

            this.service.addLookupValue(lookupValues).subscribe(
                null,
                (err) => alert(err.error),
                () => {
                    this.form.reset();

                    this.refreshTable.emit();
                }
            );
        } else {
            alert("Please fill in mandatory fields");
        }
    }
}
